package com.loyola.acessoescola.ui.addnew

enum class AddNewErrorMessages(val message: String) {
    SAVE_FAIL("Erro ao salvar o registro"),
    EMPTY_FIELDS("Nenhum campo pode estar vazio"),
    INVALID_CPF("CPF inválido"),
    INVALID_PHONE("Número de Telefone inválido")
}